module.exports = __webpack_public_path__ + "img/TGT-Melissa-Marshall-27 1.0c974753.jpg";